export const customerType = {
  GET_CUSTOMERS_LIST: "GET_CUSTOMERS_LIST",
};
